define([], function () {

    var levels = {
        DEBUG: 5,
        LOG: 4,
        TABLE: 4,
        TIME: 4,
        DIR: 4,
        INFO: 3,
        WARN: 2,
        ASSERT: 1,
        ERROR: 1
    };

    Object.freeze(levels);

    return levels;
});
//# sourceMappingURL=Levels.js.map
